import axios from 'axios';
import { useSession } from 'next-auth/react';
import React from 'react';

import {
  clearPendingGcpExternalId,
  readPendingGcpExternalId,
} from '@/hooks/cloudPricing/pendingGcpConnection';
import { useClaimGcpConnection } from '@/hooks/cloudPricing/useGcpConnections';

export function useClaimPendingGcpConnection() {
  const { data: session, status } = useSession();
  const claim = useClaimGcpConnection();
  const inFlightRef = React.useRef(false);

  React.useEffect(() => {
    if (status !== 'authenticated') return;
    if (!session?.user?.tenant_id) return;
    const externalId = readPendingGcpExternalId();
    if (!externalId || inFlightRef.current) return;

    inFlightRef.current = true;
    void claim
      .mutateAsync(externalId)
      .then(() => {
        clearPendingGcpExternalId();
      })
      .catch((error) => {
        const statusCode = axios.isAxiosError(error) ? error.response?.status : undefined;
        if (statusCode === 403 || statusCode === 400 || statusCode === 404) {
          clearPendingGcpExternalId();
          return;
        }
        inFlightRef.current = false;
      });
  }, [claim, session?.user?.tenant_id, status]);
}
